module.exports = __webpack_public_path__ + "img/ingredienten-gewokte-kip-broccoli.9c9722d6.jpeg";